import { type GroupOrderJoinPreviewQuery } from '../graphql/GroupOrderJoin.generated';

// ─────────────────────────────────────────────────────────────────────────────

export function checkIfPreviewError(params: CheckIfPreviewErrorParams) {
  const { preview } = params;

  return preview?.__typename === 'MultipartyOrderNotFound' || preview?.__typename === 'OrderLocked';
}

// ─── Types ───────────────────────────────────────────────────────────────────

type GroupOrderPreview = GroupOrderJoinPreviewQuery['multipartyOrderPreview'];
type CheckIfPreviewErrorParams = { preview: GroupOrderPreview | undefined };
